import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';

// Set on requests for secondary/auxiliary data (e.g. widgets that enrich a
// page but aren't its primary content) so a 400/404 response fails locally
// instead of redirecting the whole page to /404.
export const SKIP_404_REDIRECT = new HttpContextToken<boolean>(() => false);

export const error404Interceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        (error.status === 400 || error.status === 404) &&
        req.method === 'GET' &&
        !req.context.get(SKIP_404_REDIRECT)
      ) {
        router.navigate(['/404']);
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
};
